import type { Agenda, AgendaService, AgendaSpecial, AgendaEvent } from './types';

const DAY_CODES = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'] as const;

/** Vérifie si un rrule contient un jour donné dans BYDAY */
function rruleHasDay(rrule: string, dayCode: string): boolean {
  const match = rrule.match(/BYDAY=([A-Z,]+)/);
  if (!match) return false;
  return match[1].split(',').includes(dayCode);
}

export function getSlotsForDay(agenda: Agenda, dayOfWeek: number): AgendaService[] {
  const dc = DAY_CODES[dayOfWeek];
  return agenda.services
    .filter((s) => (s.type === 'slot' || s.type === 'promo') && rruleHasDay(s.recurrence?.rrule ?? '', dc))
    .sort((a, b) => a.recurrence.start.localeCompare(b.recurrence.start));
}

export function getOpeningForDay(agenda: Agenda, dayOfWeek: number): { start: string; end: string } | null {
  const dc = DAY_CODES[dayOfWeek];
  const isClosed = agenda.closures.some((c) => rruleHasDay(c.recurrence?.rrule ?? '', dc));
  if (isClosed) return null;
  const svc = agenda.services.find((s) => s.type === 'service' && rruleHasDay(s.recurrence?.rrule ?? '', dc));
  return svc ? { start: svc.recurrence.start, end: svc.recurrence.end } : null;
}

export function getSpecialToday(agenda: Agenda): AgendaSpecial | null {
  const today = new Date().toISOString().slice(0, 10);
  return agenda.specials.find((s) => s.date === today) ?? null;
}

export function getSpecialForDate(agenda: Agenda, dateStr: string): AgendaSpecial | null {
  return agenda.specials.find((s) => s.date === dateStr) ?? null;
}

export function getEventsForDate(agenda: Agenda, dateStr: string): AgendaEvent[] {
  return agenda.events.filter((e) => e.date === dateStr);
}
